"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsStandaloneMode = void 0;
const react_1 = __importDefault(require("react"));
const oneaudi_os_react_1 = require("@volkswagen-onehub/oneaudi-os-react");
/**
 * Checks if the feature app is running in standalone mode or if it is integrated by an configured root feature app..
 */
function useIsStandaloneMode() {
    var _a;
    const isStandaloneRef = react_1.default.useRef();
    if (typeof isStandaloneRef.current !== "undefined") {
        return isStandaloneRef.current;
    }
    const rootConfig = (_a = (0, oneaudi_os_react_1.root)()) === null || _a === void 0 ? void 0 : _a.config;
    if (!(rootConfig === null || rootConfig === void 0 ? void 0 : rootConfig.CONTENTFUL_TOKEN) || !(rootConfig === null || rootConfig === void 0 ? void 0 : rootConfig.CONTENTFUL_SPACE)) {
        isStandaloneRef.current = true;
    }
    else {
        isStandaloneRef.current = false;
    }
    return isStandaloneRef.current;
}
exports.useIsStandaloneMode = useIsStandaloneMode;
//# sourceMappingURL=useIsStandaloneMode.js.map